<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5 d-body">
  <div>
    <div class="container assign-course">
      <div class="row assign-nav">
        <div class="col-lg-1 col-sm-12"></div>
        <div class="col-lg-10 col-sm-12">
          <ul class="nav nav-pills mb-3 justify-content-center mt-5">
            <li class="nav-item click">
              <a
                class="nav-link active"
                routerLink="/assignCourse/selectCourse"
              >
                <span class="number">1</span> Select Courses</a
              >
            </li>
            <li class="nav-item click">
              <a class="nav-link" routerLink="/assignCourse/selectParticipant">
                <span class="number">2</span>Select Participants</a
              >
            </li>
            <li class="nav-item click">
              <a class="nav-link" routerLink="/assignCourse/chooseDate">
                <span class="number">3</span> Choose Due Date</a
              >
            </li>
            <li class="nav-item click">
              <a class="nav-link" routerLink="/assignCourse/confirmation"
                ><span class="number">4</span>Confirmation</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-sm-12">
          <p class="font-light font18 mt-4 p">
            Please select the course(s) you want to assign to individual(s) or
            groups(s).
          </p>
        </div>
        <div class="col-lg-9 col-sm-12 sm-mt">
          <div class="nav-card bg-white px-4 py-3">
            <ul class="nav nav-pills" id="pills-tab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="Courses-tab"
                  data-toggle="pill"
                  href="#Courses"
                  role="tab"
                  aria-controls="Courses"
                  aria-selected="false"
                  >Courses</a
                >
              </li>
            </ul>
          </div>

          <div class="tab-content" id="pills-tabContent">
            <div
              class="tab-pane fade show active"
              id="Courses"
              role="tabpanel"
              aria-labelledby="Courses-tab"
            >
              <div class="bg-white pt-1 px-4">
                <div
                  class="row align-items-center sm-reverse table-search-container"
                >
                  <div
                    class="text-green font12 font-bold col-lg-2 col-sm-12 sm-text-center sm-mt sm-mb-2"
                  >
                    ADD FILTER
                  </div>
                  <div class="table-search col-lg-7 col-sm-12">
                    <input
                      type="text"
                      placeholder="Search"
                      #query
                      (keyup)="filter(query.value)"
                    />
                  </div>
                  <div
                    class="sort col-lg-3 col-sm-12 sm-mt sm-mb-2 sm-text-center"
                  >
                    <span class="font-bold font14 text-grey mr-3">SORT BY</span>
                    <span class="dropdown click">
                      <span
                        class="font-bold text-green font12 dropdown-toggle"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        >Name <i class="fa fa-chevron-down"></i
                      ></span>
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a
                          class="dropdown-item click line-under"
                          (click)="sortByName()"
                          >Name</a
                        >
                        <a class="dropdown-item click">Class</a>
                        <a class="dropdown-item click">State</a>
                      </div>
                    </span>
                  </div>
                </div>

                <div class="col-12 click px-3 py-2 font14">
                  <input
                    type="checkbox"
                    (change)="checkUncheckAll()"
                    [(ngModel)]="isCheck"
                    class=""
                  />
                  Select All
                </div>
                <div
                  class="row my-4"
                  *ngFor="
                    let course of courses
                      | paginate : { itemsPerPage: 5, currentPage: p };
                    index as i
                  "
                >
                  <div class="col-lg-4 col-md-6 col-sm-6 click">
                    <input
                      (click)="selectDeselectCourses(course?.code)"
                      type="checkbox"
                      id="checkbox{{ i }}"
                      [(ngModel)]="course.isSelected"
                      class="checkbox"
                    />
                    <label for="checkbox{{ i }}" class="mb-0">
                      <div class="p-r click course">
                        <img
                          src="{{ course?.imageUrl }}"
                          alt=""
                          class="courseImg"
                        />

                        <div class="check d-none badge-left">
                          <img src="assets/icons/check.png" alt="" />
                        </div>
                      </div>
                    </label>
                  </div>
                  <div class="col-lg-8 col-md-6 col-sm-8 my-auto">
                    <p class="font-bold">
                      {{ course?.title }}
                    </p>
                    <p class="text-grey font12">
                      {{ course?.category?.name }} |
                      {{ course?.subCategory?.name }}
                    </p>
                    <div
                      class="mt-4 d-flex justify-content-between record py-2 px-3 col-lg-7 col-sm-12"
                    >
                      <div>
                        <i class="fa fa-calendar"></i>
                        <span class="ml-4">{{ course?.createdAt | date }}</span>
                      </div>
                      <div>
                        <i class="fa fa-clock-o"></i>
                        <span class="ml-4">{{ course?.duration }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-end">
                  <pagination-controls
                    previousLabel="Prev"
                    (pageChange)="p = $event"
                    nextLabel="Next"
                    responsive="true"
                    class="my-pagination"
                  ></pagination-controls>
                </div>
              </div>
              <div class="my-5 d-flex justify-content-end">
                <a
                  id="learningPath-tab"
                  data-toggle="pill"
                  href="#learningPath"
                  role="tab"
                  aria-controls="learningPath"
                  aria-selected="false"
                >
                  <button 
                    class="btn btn-secondary" 
                    [disabled]="selectedCourses.length === 0"
                    (click)="continue()"
                  >
                    Continue
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-auto">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>
